import { IIndicatorStatus } from './interfaces';

export const indicatorStatuses: { [key: string]: IIndicatorStatus } = {
  UNAVAILABLE: { level: 0, description: 'Unavailable' },
  NEEDS_ATTENTION: { level: 1, description: 'Needs attention' },
  FAIR: { level: 2, description: 'Fair' },
  GOOD: { level: 3, description: 'Good' },
};
